import { useMemo } from 'react'
import useAxios from 'axios-hooks'

const namespace = 'scholarships-stage'

export const useSave = ({ editProgramId } = {}) => {
  
  const [
    { data: createStagedData, loading: loadingStagedCreate, error: errorStagedCreate },
    createStagedProgram,
  ] = useAxios(
    { url: namespace, method: 'POST' },
    { manual: true }
  )
  
  const [
    { data: editStagedData, loading: loadingStagedEdit, error: errorStagedEdit },
    editStagedProgram,
  ] = useAxios(
    { url: `${namespace}/${editProgramId}`, method: 'PUT' },
    { manual: true }
  )

  return useMemo(() => ({
    // Create
    createStagedData,
    loadingStagedCreate,
    errorStagedCreate,
    createStagedProgram,
    // Edit
    editStagedData,
    loadingStagedEdit,
    errorStagedEdit,
    editStagedProgram,
  }), [
    // Create
    createStagedData,
    loadingStagedCreate,
    errorStagedCreate,
    createStagedProgram,
    // Edit
    editStagedData,
    loadingStagedEdit,
    errorStagedEdit,
    editStagedProgram,
  ])
}
